import { TournamentReward } from '../form';

import { TournamentRewardType } from 'v2/constants';

export const getRewardPlacesLabel = (rewards: TournamentReward[], index: number) => {
  const previousCount = rewards.slice(0, index).reduce((acc, reward) => {
    const count = Number(reward.count);
    return Number.isFinite(count) && count > 0 ? acc + count : acc;
  }, 0);

  const currentCount = Number(rewards[index]?.count);

  if (!Number.isFinite(currentCount) || currentCount <= 0) {
    return 'Places: N/A';
  }

  const start = previousCount + 1;
  const end = previousCount + currentCount;

  return end === start ? `Places: ${start}` : `Places: ${start}-${end}`;
};

export const getRewardValueFieldConfig = (
  type: TournamentRewardType
): {
  label: string;
} => {
  switch (type) {
    case TournamentRewardType.BALANCE:
      return { label: 'Amount' };
    case TournamentRewardType.DEFAULT_CONTEST_TICKET:
      return { label: 'Tickets' };
    case TournamentRewardType.CUSTOM:
      return { label: 'Description' };
    default:
      return { label: 'Value' };
  }
};
